<template>

  <md-card class="md-card">
    <md-card-header :data-header-animation="false"><h3>Kommende forsendelser</h3></md-card-header>
    <md-card-content>
      <table width="100%" border="0">
        <tr>
          <th colspan="2"></th>
          <th v-for="day in getDays()">{{ day.format("ddd. DD/MM") }}</th>
        </tr>
        <tr v-for="shop in shops" class="text-center" :class="{'table-info' : shop.mys_account == activeAccountId}">
          <td><input type="radio" name="shopSelect" :value="shop.mys_account" v-model="activeAccountId"></td>
          <td>{{ shop.accountName }}</td>
          <td v-for="dayStat in getGridData(shop.mys_account)"><b v-if="dayStat.Count > 0">{{ dayStat.Count }}</b><span
              v-if="dayStat.Count === 0">{{ dayStat.Count }}</span></td>
        </tr>
      </table>
    </md-card-content>

    <md-card-actions md-alignment="left">
      <slot name="footer"></slot>
    </md-card-actions>

  </md-card>
</template>

<script>
import {mapGetters} from "vuex";
import store from "@/store";
import moment from "moment";

export default {
  name: "ShopGridSelector",
  data() {
    return {
      selectedAccountId: ''
    }
  },
  computed: {
    ...mapGetters(["shops", "user", "warehouseShipments"]),

    activeAccountId: {
      set(value) {
        if (!value)
          return;

        this.$route.params.accountId = value;
        this.$router.push({name: this.$route.name, params: this.$route.params});
        store.commit("SET_ACCOUNT", this.user.roles.filter(r => r.mys_account === value)[0]);
      },
      get() {
        if (!store.getters.activeAccount)
          return null;

        return store.getters.activeAccount.mys_account;
      }
    }
  },
  methods: {

    getDays() {
      let d = new moment();
      let days = [];
      for (let i = 0; i < 9; i++) {
        days.push(d.clone());
        d.add(1, "days");
      }
      return days;
    },

    getGridData(shop) {

      let d = new moment();
      let daysArray = [];
      for (let i = 0; i < 9; i++) {
       
       
        let shipments = [];

        if (i == 0)
          shipments = this.warehouseShipments.filter(s => s._mys_OwningAccount_value === shop && moment(s.mys_date_est_send) <= d);
        else 
          shipments = this.warehouseShipments.filter(s => s._mys_OwningAccount_value === shop && moment(s.mys_date_est_send).format("DD/MM") === d.format("DD/MM"));

          daysArray.push({
            Date: d.format("DD/MM"), Count:
            shipments.length
          });

          d.add(1, "days");
        }

        return daysArray;
      }
    ,
    }
  }
</script>

<style scoped>

</style>